module.exports = __webpack_public_path__ + "static/media/bizbanner.38ff3e4d.png";